module.exports = __webpack_public_path__ + "img/img_nav_logout-w.1e144873.svg";